import { conditions } from "helpers";
import { spliteStringPerLine } from "helpers/regex";
import { ConditionName } from "interfaces";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "redux-share";

const DisplaySubtitle = () => {
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);
    const { subtitleText } = useAppSelector(
        ({ videoData: { subtitleText, selectedSubtitle } }) => ({ subtitleText, selectedSubtitle }),
        shallowEqual
    );

    const subtitlePosition = () => {
        let styles = "";
        if (conditions(ConditionName.isComplexPortrait)) styles = `!pl-bottom-0`;
        else if (conditions(ConditionName.isLock)) styles = "pl-bottom-3";
        else if (conditions(ConditionName.isActiveElements)) styles = "pl-bottom-[100px]";
        else if (!conditions(ConditionName.isActiveElements)) styles = "pl-bottom-3";

        return styles;
    };

    return (
        <>
            {(!conditions(ConditionName.isMiniPlayer) || conditions(ConditionName.isFullMobilePortrait)) && (
                <div
                    id={"subtitle-id"}
                    style={{
                        fontSize: "30px",
                        direction: "ltr",
                        opacity:
                            conditions(ConditionName.isComplexPortrait) && conditions(ConditionName.isActiveElements)
                                ? 0.5
                                : settings.brightness / 100
                    }}
                    className={`pl-absolute pl-w-full pl-mx-auto pl-text-center pl-text-[36px] ${
                        conditions(ConditionName.isComplexPortrait) && "!pl-text-[13px]"
                    } ${conditions(ConditionName.isTouchScreenLandscape) && "!pl-text-[24px]"} pl-font-normal ${subtitlePosition()}`}
                >
                    {spliteStringPerLine(subtitleText!).map((text, index) => (
                        <p
                            style={{ backgroundColor: `#${settings.subtitle_background_color}`, color: `#${settings.subtitle_text_color}` }}
                            key={index}
                            className={`pl-w-max pl-px-2 pl-mx-auto pl-bg-opacity-[0.60]`}
                        >
                            {text}
                        </p>
                    ))}
                </div>
            )}
        </>
    );
};

export default DisplaySubtitle;
